import { skipToken, useMutation, useQuery } from "@tanstack/react-query";
import { type FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import { trpc } from "../../app/trpc.js";
import { Button, Input, Label, Notice, PageTitle, Screen, Spinner } from "../../ui/index.js";

/** После входа: салон с незавершённой настройкой попадает в мастер настройки (этап 6), иначе в календарь; без салона предлагаем создать. */
export function HomePage() {
  const { t } = useTranslation();
  const salons = useQuery(trpc.auth.mySalons.queryOptions());
  const [name, setName] = useState("");
  const create = useMutation(trpc.auth.createSalon.mutationOptions({ onSuccess: () => salons.refetch() }));

  const first = salons.data?.[0];
  const onboarding = useQuery(trpc.onboarding.status.queryOptions(first ? { salonId: first.id } : skipToken));

  if (salons.isPending) return <Spinner />;
  if (first) {
    if (onboarding.isPending) return <Spinner />;
    return <Navigate to={`/s/${first.id}/${onboarding.data?.needed ? "onboarding" : "calendar"}`} replace />;
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    create.mutate({ name: name.trim() });
  };
  return (
    <Screen>
      <PageTitle>{t("noSalon.title")}</PageTitle>
      <p className="mb-4 text-slate-600">{t("noSalon.text")}</p>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <Label htmlFor="salon">{t("noSalon.nameLabel")}</Label>
          <Input id="salon" required minLength={2} value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        {create.isError && <Notice kind="error">{t("common.error")}</Notice>}
        <Button type="submit" className="w-full" disabled={create.isPending}>
          {t("noSalon.create")}
        </Button>
      </form>
    </Screen>
  );
}
